import script from "./BlogSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogSlider.vue?vue&type=script&setup=true&lang=js"

export default script